import React from 'react';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import OpenURL from 'shared/ui/icons/General/OpenURL';

import styles from './OpenLinkNewWindow.module.scss';

interface IOpenLinkNewWindowProps {
    url: string,
    className?: string,
    styleText?: string,
}

const OpenLinkNewWindow: React.FC<IOpenLinkNewWindowProps> = ({url, className, styleText}) => {

    return (
        <div className={cn(
            styles.container,
            styles.colorIcon,
        )}>
            <span className={cn(styles.content, styleText)}>{url}</span>
            <div className={styles.link}>
                <a
                    href={url}
                    target="_blank"
                    title={`${t`Открыть в новой вкладке`} - ${url}`}
                    className={className}
                    rel="noopener noreferrer"
                >
                    <span className={styles.openURL}>
                        <OpenURL/>
                    </span>
                </a>
            </div>

        </div>
    );
};

export default OpenLinkNewWindow;